import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {

    applyColor(ionicColor: string = 'theme', color: string = '#199EB8') {
        const ionicColorRgb = this.hexToRgb(color);
        const baseColorKey = `--ion-color-${ionicColor}`;
        const root = document.documentElement;
        root.style.setProperty(baseColorKey, color);
        root.style.setProperty(`${baseColorKey}-rgb`, `${ionicColorRgb.r},${ionicColorRgb.g},${ionicColorRgb.b}`);

        // calculate contrast color
        const contrastColor = (ionicColorRgb.r * 299 + ionicColorRgb.g * 587 + ionicColorRgb.b * 114) / 1000 > 186 ? 'black' : 'white';
        root.style.setProperty(`${baseColorKey}-contrast`, contrastColor);
        root.style.setProperty(`${baseColorKey}-contrast-rgb`, `${ionicColorRgb.r},${ionicColorRgb.g},${ionicColorRgb.b}`);

        // calculate shade and tint colors
        const shadeColor = this.rgbToHex(
            +(ionicColorRgb.r * 0.75).toFixed(0), 
            +(ionicColorRgb.g * 0.75).toFixed(0), 
            +(ionicColorRgb.b * 0.75).toFixed(0)
            );
        root.style.setProperty(`${baseColorKey}-shade`, shadeColor);
    }

    resetColors() { 
        this.applyColor('theme', '#199EB8');
    }

    private hexToRgb(hex: string) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    private rgbToHex(r: number, g: number, b: number) {
        return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }
}